<template>
  <p class="mb-3">O preço médio é calculado a partir das entradas que ocorrerarm entre os inventários do tipo "fechamento".</p>
  <TableFull v-model="control" :headers="headers" :items="items" dense offline>
    <template v-slot:actions="{ item }">
      <TheToolTip label="Ver Inventário" v-if="item.idInventory"> <TableIconButton icon="fa-eye" @click="navigate('inventoryUpdate', { id: item.idInventory })" /></TheToolTip>
    </template>

    <template v-slot:avgPrice="{ item }"> {{ formatMoneyS(item.avgPrice) }} </template>
  </TableFull>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { get } from '@/crud'
import { useNavigation } from '@/composables/useNavigation'
import { useFormat } from '@/composables/useFormat'
//  Composables
const { navigate } = useNavigation()
const { formatFullDate, formatMoneyS, formatDate } = useFormat()
// Props
const props = defineProps({
  id: [String, Number],
})
// Controller
const api = 'item/searchAvgPriceByItem'

const items = ref([])

const control = ref({
  page: 1,
  limit: 20,
  pages: 0,
  total: 0,
  order: [{ direction: 'ASC', column: 'id', name: 'Código' }],
})

const headers = ref([
  { title: 'Início Período', field: 'startDate', format: formatFullDate },
  { title: 'Fim Período', field: 'endDate', format: formatFullDate },
  { title: 'Inventário', field: 'idInventory' },
  { title: 'Depósito', field: 'warehouseName' },
  { title: 'Preço Médio Período', field: 'price', format: formatMoneyS },
  { title: 'Ações', field: 'actions', itemClass: 'w-1/12', disableOrder: true, headerClass: 'justify-center' },
])

// Methods
const loadItems = async () => {
  const filters = [
    {
      column: 'idItem',
      value: props.id,
      operator: '=',
    },
  ]

  const query = {
    params: {
      page: control.value.page,
      limit: control.value.limit,
      order: control.value.order,
      filters,
    },
  }

  const raw = await get(api, query)
  items.value = raw.data
  control.value.pages = Math.ceil(raw.total / control.value.limit)
  control.value.total = raw.total
}
// Watchers
watch(
  () => props.id,
  () => {
    loadItems()
  },
  { deep: true },
)

watch(
  () => control.value,
  () => {
    loadItems()
  },
  { deep: true },
)

// Life Cycle
onMounted(() => {
  loadItems(1)
})
</script>
